import React from 'react';

function TrendChart({ trend }) {
    if (!trend || !trend.length) return null;
    const maxVal = Math.max(...trend.map((t) => Math.max(t.joins, t.exits)), 1);
    const barH = 80;
    return (
        <div
            style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8, padding: 16, marginBottom: 24 }}
        >
            <h3 style={{ marginTop: 0, fontSize: 14, color: '#666' }}>Weekly Trend (SOS Joins vs EOS Exits)</h3>
            <div style={{ display: 'flex', gap: 4, alignItems: 'flex-end', height: barH + 30, marginTop: 12 }}>
                {trend.map((t) => (
                    <div key={t.week} style={{ flex: 1, textAlign: 'center' }}>
                        <div
                            style={{
                                display: 'flex',
                                gap: 2,
                                justifyContent: 'center',
                                alignItems: 'flex-end',
                                height: barH,
                            }}
                        >
                            <div
                                style={{
                                    width: 10,
                                    height: `${(t.joins / maxVal) * barH}px`,
                                    background: '#2196f3',
                                    borderRadius: '2px 2px 0 0',
                                }}
                                title={`${t.joins} SOS joins`}
                            />
                            <div
                                style={{
                                    width: 10,
                                    height: `${(t.exits / maxVal) * barH}px`,
                                    background: '#f44336',
                                    borderRadius: '2px 2px 0 0',
                                }}
                                title={`${t.exits} EOS exits`}
                            />
                        </div>
                        <div style={{ fontSize: 9, color: '#999', marginTop: 4 }}>{t.week.slice(5)}</div>
                    </div>
                ))}
            </div>
            <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 8 }}>
                <span style={{ fontSize: 11, color: '#2196f3' }}>■ SOS Joins</span>
                <span style={{ fontSize: 11, color: '#f44336' }}>■ EOS Exits</span>
            </div>
        </div>
    );
}

export default TrendChart;
